var _regeneratorRuntime = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var path = require('path'); // Creates a DB manifest file and saves it in IPFS


var createDBManifest =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(ipfs, name, type, accessControllerAddress) {
    var manifest, dag;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            manifest = {
              name: name,
              type: type,
              accessController: path.join('/ipfs', accessControllerAddress)
            };
            _context.next = 3;
            return ipfs.object.put(Buffer.from(JSON.stringify(manifest)));

          case 3:
            dag = _context.sent;
            return _context.abrupt("return", dag.toJSON().multihash.toString());

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function createDBManifest(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = createDBManifest;